import {Link} from "react-router";
import {useContext} from "react";
import { ReactSVG } from 'react-svg';

import GeneralContext from "../contexts/Gneral.tsx";
import ActivityContext from "../contexts/Activity.tsx";

export function SelectAvatar () {
    const  data  = useContext(GeneralContext);
    const  {avatar , setAvatar}  = useContext(ActivityContext);
    return (<div  className={'builder-screen'}>
        <div className={'selectingAside'}>
            <div className={'aside-content'}>
                <h1>{data?.contents.selectAvatarScreenHeading}</h1>
                <p>{data?.contents.selectAvatarScreenContent}</p>
            </div>
            <div className={"avatars-list"}>
                <ul>
                    {data?.avatars && data.avatars.map( (item : any) =>{
                        return <li key={item.color}>
                            <button aria-label={item.ariaLabel}
                            onClick={()=>{
                                setAvatar(item)
                            }}
                            >
                                <ReactSVG src={item.image}
                                      afterInjection = {(svg) => {
                                          svg.setAttribute('width', item.width+'px');
                                          svg.setAttribute('height', item.height+'px');
                                          svg.style.setProperty('--avatar-width', item.width+'px')
                                      }}
                                />
                            </button>
                        </li> ;
                    })}
                </ul>
            </div>
            <Link  to={'/select-activity'} className={'btn'+ ( !avatar ? ' disabled' : '')}>בחרתי, אפשר להמשיך</Link>
        </div>
        <div className={'visualArea'}>
            <div className={'personArea ' + ( !avatar ? 'initial' : '')}>
                {/*get the selected avatar*/}
                <span className={'personItem'}>
                    {avatar ? <ReactSVG
                        src={avatar.image}
                            beforeInjection = {(svg) => {
                                svg.setAttribute('width', (avatar.width * 1.61)+'px')
                                svg.setAttribute('height', (avatar.height * 1.61)+'px')
                            }}
                    />: '+'}
                </span>
                { avatar ? <ReactSVG className={'halo'} src={avatar.halo}  afterInjection={(svg) => {
                    svg.setAttribute('width', avatar.haloWidth + 'px')
                    svg.setAttribute('height', avatar.haloHeight+ 'px')
                }}/>: ''}
            </div>
        </div>
    </div>);
}